module.exports = __webpack_public_path__ + "static/bambam-a4555e80f4ea2dc615ea7b57995d09ea.png";